<template>
  <base-dialog
    class="sheet-filter-dialog"
    :visible="dialogVisible"
    border-radius="none"
    show-close
    @closed="close"
  >
    <template v-slot:header>
      <div class="font-h1">设置筛选条件</div>
    </template>
    <div class="body" v-ps>
      <div class="body-row" v-if="filledPreCondition">
        <div class="tip">
          <span class="font-main">预设条件</span>
          <br />
          <span class="font-main font-addition">关联表控件所配置的预设筛选条件</span>
        </div>

        <div class="panel">
          <div class="panel-content">
            <div class="panel-content-row">
              <condition-list
                disabled
                :conditions="filledPreCondition"
                :from="from"
                :search-sheet="searchSheet"
                :rely-sheet="relySheetInfo"
              ></condition-list>
            </div>
          </div>
        </div>
      </div>
      <div class="body-row">
        <div class="tip">
          <span class="font-main">自定义条件</span>
          <br />
          <span class="font-main font-addition">设置筛选条件后，满足条件的数据才会显示</span>
        </div>
        <div class="panel">
          <div class="panel-content">
            <div class="panel-content-row">
              <condition-list
                v-if="dialogVisible"
                :conditions="conditions"
                ref="conditionList"
                :search-sheet="searchSheet"
                :rely-sheet="relySheetInfo"
                :from="from"
              ></condition-list>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <base-button v-if="showSaveBtn" @click="submit(true)">存为视图</base-button>
      <div class="tail-row-right">
        <base-button type="text" @click="clearFilters">清空筛选</base-button>
        <base-button @click="close">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import BaseButton from "@/components/UIComponents/Button"
import { verifyCondition } from "@/utils/sheet"
import { getCompareMethods } from "@/utils/workFlow"

export default {
  name: "sheet-filter",
  components: {
    BaseDialog,
    BaseButton,
    ConditionList
  },
  props: {
    conditionList: {
      type: Array,
      default: () => []
    },
    dialogVisible: Boolean,
    showSaveBtn: {
      type: Boolean,
      default: false
    },
    searchSheet: {
      type: Object,
      required: true,
      default: () => ({
        sheetId: null, // 搜索工作表ID
        controls: [] // 搜索控件列表
      })
    },
    // 变量来源工作表(当需要选择当前工作表控件时传入)
    relySheetInfo: Object,
    from: {
      type: String,
      default: "sheet_frontend" // sheet_frontend,sheet_backend,workflow_gateway,workflow_search
    }
  },
  watch: {
    conditionList: {
      immediate: true,
      handler() {
        this.conditions = this._.cloneDeep(this.conditionList) || []
      }
    }
  },
  data() {
    return {
      conditions: [], // 条件列表
      filledPreCondition: null
    }
  },
  methods: {
    fillPreCondition(preCondition, sheetData, isRef) {
      if (this._.isEmpty(preCondition)) return null
      let data = sheetData?.data || {}
      this.filledPreCondition = isRef
        ? this._.cloneDeep(preCondition)?.map(c => {
            return c?.map(item => {
              item.varItems = item.varItems.flatMap(varItem => {
                if (!varItem.var) {
                  return [varItem]
                }
                let { compareType } = getCompareMethods({ type: item.type, from: this.from })
                switch (compareType) {
                  case "String":
                  case "Number":
                    if (this._.isArray(data[varItem.value])) {
                      return data[varItem.value].map(v => ({ var: false, value: v }))
                    }
                    varItem.var = false
                    varItem.value = data[varItem.value]
                    return varItem
                  case "Select":
                    return (data[varItem.value] || []).map(val => ({ var: false, value: val }))
                }
              })
              return item
            })
          })
        : preCondition
    },
    submit(createViewFlag) {
      let { result, msg } = verifyCondition("submit", this.conditions)
      if (!result) {
        this.$message.error(msg)
        return
      }
      this.$emit("submit", this._.cloneDeep(this.conditions), createViewFlag)
      this.close()
    },
    // 清空筛选条件并关闭
    clearFilters() {
      this.justClear()
      this.$emit("submit", [])
    },
    // 清空筛选条件并关闭,不触发提交
    justClear() {
      this.conditions = []
      this.close()
    },
    // 当save为true时，筛选条件被保存
    close() {
      this.$emit("update:dialogVisible", false)
    },
    addColCondition(col) {
      let curColFilter = {
        key: col.cid,
        type: col.type,
        compareMethod: null,
        value: null,
        varItems: []
      }
      if (this.conditions.length === 0) {
        this.conditions = [[curColFilter]]
      } else {
        let finalIndex = this.conditions.length - 1
        this.conditions[finalIndex].push(curColFilter)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sheet-filter-dialog {
  display: flex;
  flex-flow: column;
  ::v-deep .el-dialog__body {
    padding: 0 !important;
    display: flex;
    flex-flow: column;
    flex: auto;
  }
  .body-row {
    padding: 0 24px;
    .tip {
      padding-top: 14px;
      .font-addition {
        color: $color-font-second;
        line-height: 20px;
      }
    }
    .panel {
      padding-bottom: 14px;
      .panel-title {
        font-weight: 600;
      }
      .panel-content {
        .panel-content-row {
          .font-main {
            margin-bottom: 6px;
          }
          .el-select {
            width: 100%;
          }
        }
      }
    }
  }
  .footer {
    display: flex;
    .tail-row-right {
      margin-left: auto;
      & > * {
        margin-left: 8px;
      }
    }
  }
}
</style>
